import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/**
 * US-010 — the subscription banner is a shared component (not a feature domain),
 * so its dashboard registration lives here. It is already self-contained (owns its
 * own subscription query), so the card is the component itself.
 */
registerSurfaceItem("dashboard-banners", {
  id: "subscription",
  order: 10,
  Component: lazyNamed(
    () => import("@/components/SubscriptionBanner"),
    "SubscriptionBanner",
  ),
});
